import styled from '@independent-software/typeui/styles/Theme';
import * as React from 'react';

interface IProps {
  className?: string;
  enabled?: boolean;
}

const StatusBase = (props: IProps) => {
  return (
    <div className={props.className}>
      <Light/>
      {props.enabled ? "Enabled" : "Disabled"}
    </div>
  )
}

const Light = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 100%;
  transition: background-color ease-in-out 250ms,
              box-shadow ease-in-out 250ms;
`

const Status = styled(StatusBase)`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  ${Light} {
    background: ${p => p.enabled ? '#00aa00' : '#ff4040'};
    box-shadow: 0px 0px 4px ${p => p.enabled ? '#00aa00' : '#ff4040'};
  }
`

export { Status }
